<template>
  <div>
    <b-card class="pa-0 tabs">
      <Tabs :theme="theme" v-model="tab">
        <TabItem v-for="item in tabs" :key="item.id" :name="item.id">
          <template #name>
            {{ item.name }}
          </template>
        </TabItem>
      </Tabs>
    </b-card>
    <template v-for="(item, i) in tabs">
      <reason-master v-show="tab == i" v-if="item.id == menu.REASON_MASTER" :key="'c'+item.id"></reason-master>
      <cause-of-death v-show="tab == i" v-if="item.id == menu.CAUSE_OF_DEATH" :key="'c'+item.id"></cause-of-death>
      <termination-reasons v-show="tab == i" v-if="item.id == menu.TERMINATION_REASON" :key="'c'+item.id"></termination-reasons>
      <zone v-show="tab == i" v-if="item.id == menu.ZONE" :key="'c'+item.id"></zone>
      <organ v-show="tab == i" v-if="item.id == menu.ORGAN" :key="'c'+item.id"></organ>
      <multiple-organ v-show="tab == i" v-if="item.id == 'multi_29'" :key="'c'+item.id"></multiple-organ>
      <contact v-show="tab == i" v-if="item.id == menu.CONTACT" :key="'c'+item.id"></contact>
      <blood-group v-show="tab == i" v-if="item.id == menu.BLOOD_GROUP" :key="'c'+item.id"></blood-group>
      <file-upload v-show="tab == i" v-if="item.id == menu.FILE_UPLOAD" :key="'c'+item.id"></file-upload>
      <qualification v-show="tab == i" v-if="item.id == menu.QUALIFICATION" :key="'c'+item.id"></qualification>
      <department v-show="tab == i" v-if="item.id == menu.DEPARTMENT" :key="'c'+item.id"></department>
    </template>
  </div>
</template>

<script>
import menuConstants from "../assets/constants/menu.constants";
import BloodGroup from "../components/masters/BloodGroup.vue";
import CauseOfDeath from "../components/masters/CauseOfDeath.vue";
import Contact from "../components/masters/Contact.vue";
import Department from "../components/masters/Department.vue";
import FileUpload from "../components/masters/FileUpload.vue";
import MultipleOrgan from "../components/masters/MultipleOrgan.vue";
import Organ from "../components/masters/Organ.vue";
import Qualification from "../components/masters/Qualification.vue";
import TerminationReasons from "../components/masters/TerminationReasons.vue";
import ReasonMaster from "../components/masters/ReasonMaster.vue";
import Zone from "../components/masters/Zone.vue";
export default {
  components: {
    CauseOfDeath,
    TerminationReasons,
    Zone,
    Organ,
    Contact,
    BloodGroup,
    FileUpload,
    Qualification,
    Department,
    MultipleOrgan,
    ReasonMaster,
  },
  data() {
    return {
      theme: {
        nav: "white",
        navItem: "#BDBDBD",
        navActiveItem: "#556ee6",
        slider: "#556ee6",
        arrow: "#556ee6",
      },
      menu: menuConstants,
      tab: 0,
    };
  },
  computed: {
    tabs() {
      let list = [
        {
          name: "Reason Master",
          id: menuConstants.REASON_MASTER,
        },
        {
          name: "Cause of Death",
          id: menuConstants.CAUSE_OF_DEATH,
        },
        {
          name: "Termination Reasons",
          id: menuConstants.TERMINATION_REASON,
        },
        {
          name: "Zone",
          id: menuConstants.ZONE,
        },
        {
          name: "Organ and Tissue",
          id: menuConstants.ORGAN,
        },
        {
          name: "Multi Organ",
          id: "multi_29",
        },
        {
          name: "Contact",
          id: menuConstants.CONTACT,
        },
        {
          name: "Blood Group",
          id: menuConstants.BLOOD_GROUP,
        },
        {
          name: "File Upload",
          id: menuConstants.FILE_UPLOAD,
        },
        {
          name: "Qualification",
          id: menuConstants.QUALIFICATION,
        },
        {
          name: "Department",
          id: menuConstants.DEPARTMENT,
        },
      ];
      list = list.filter(({ id }) => {
        if (id == menuConstants.REASON_MASTER) return true;
        let { userRights } = this.$store.getters;
        let item = userRights.find((item) => {
          if(id == "multi_29") id = 29;
          return item.module_id == id;
        });
        if (item == null) return false;
        return item.permit == 1;
      });
      return list;
    },
  },
};
</script>

<style lang="scss">
.tabs {
  overflow: visible;
  .card-body {
    padding: 0px !important;
    .tab__slider {
      opacity: 1 !important;
    }
    .tab__nav__item {
      white-space: nowrap !important;
    }
  }
}
</style>
